import { Link, useLocation } from 'react-router-dom';
import { House, MagnifyingGlass, Plus, ChatCircle, User } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

export const BottomNav = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { user } = useAuth();

  const isActive = (path) => location.pathname === path;
  const profilePath = user ? `/users/${user.user_id}` : '/login';
  const isOnOwnProfile = user && location.pathname === `/users/${user.user_id}`;

  return (
    <div className="bottom-nav md:hidden" data-testid="bottom-nav">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-around">
        <Link to="/" className="flex flex-col items-center" data-testid="bottom-nav-home">
          <House size={24} weight={isActive('/') ? 'fill' : 'regular'} className={isActive('/') ? 'text-primary' : 'text-text_muted'} />
          <span className={`text-xs mt-1 ${isActive('/') ? 'text-primary font-medium' : 'text-text_muted'}`}>{t('nav.home')}</span>
        </Link>
        <Link to="/browse" className="flex flex-col items-center" data-testid="bottom-nav-search">
          <MagnifyingGlass size={24} weight="regular" className="text-text_muted" />
          <span className="text-xs mt-1 text-text_muted">{t('common.search')}</span>
        </Link>
        <Link to="/create" className="flex flex-col items-center" data-testid="bottom-nav-create">
          <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center -mt-6 shadow-lg">
            <Plus size={24} weight="bold" className="text-white" />
          </div>
        </Link>
        <Link to="/messages" className="flex flex-col items-center" data-testid="bottom-nav-messages">
          <ChatCircle size={24} weight={isActive('/messages') ? 'fill' : 'regular'} className={isActive('/messages') ? 'text-primary' : 'text-text_muted'} />
          <span className={`text-xs mt-1 ${isActive('/messages') ? 'text-primary font-medium' : 'text-text_muted'}`}>{t('nav.messages')}</span>
        </Link>
        <Link to={profilePath} className="flex flex-col items-center" data-testid="bottom-nav-profile">
          <User size={24} weight={isOnOwnProfile ? 'fill' : 'regular'} className={isOnOwnProfile ? 'text-primary' : 'text-text_muted'} />
          <span className={`text-xs mt-1 ${isOnOwnProfile ? 'text-primary font-medium' : 'text-text_muted'}`}>{t('nav.profile')}</span>
        </Link>
      </div>
    </div>
  );
};
